import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

const Cover = ({ context }) => {
	
	const ctxSiteStartLoaded 	= () => context.siteStartLoaded;
	const siteStartLoaded 		= ctxSiteStartLoaded();
	
	const ctxSiteEndLoaded 		= () => context.siteEndLoaded;
	const siteEndLoaded 		= ctxSiteEndLoaded();
	
	let coverClass = 'c-cover';
	if (siteStartLoaded) {
		coverClass = coverClass + ' state-start-loader';
	}
	if (siteEndLoaded) {
		coverClass = coverClass + ' state-end-loader';
	}
	
	return (
		<div className={coverClass}>
			<div className="c-cover__logo">
				<div className="c-cover__logo__inner" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 692.9 202.1"><path style="fill:#FFFFFF;" class="st0" d="M239.6,68.7h31.8c8.3,0,11.3,5.6,11.3,10.8c0,4.9-2.9,10.6-11,10.6h-32.1V68.7z M301.3,135.3v-17.9 c0-9.2-3.9-14.2-9.9-16.8c5.8-4.7,9.2-12,9.2-21.1c0-16.5-11-27.2-28-27.2h-50.9v98.3h17.9v-43.9h0.6l0.1,0h29.3 c9.5,0,14.4,4.3,14.4,13.7v17.1c0,3.8,0.3,9.1,4,13.1h19C301.9,145.4,301.3,140.3,301.3,135.3"/><polygon style="fill:#FFFFFF;" class="st0" points="152.1,52.2 123.1,128.1 94.5,52.2 74.9,52.2 112.8,150.5 133.1,150.5 171.5,52.2 "/><rect style="fill:#FFFFFF;" x="183.9" y="52.2" class="st0" width="19.3" height="98.3"/><path style="fill:#FFFFFF;" class="st0" d="M356.5,94.3v15.9h30.1c-1.8,24.7-20.1,26.6-25.8,26.6c-8.4,0-15.6-3.5-20.9-10.1c-5.2-6.5-8.1-15.5-8.1-25.4 c0-20.6,12.3-35.5,29.2-35.5c10.5,0,18.8,5.8,23.9,16.8l0.4,0.8l18.9-4.5l-0.5-1.2c-7.8-18-22.9-27.9-42.6-27.9 c-14,0-26.5,5.3-35.4,14.9c-8.6,9.4-13.3,22.3-13.3,36.5c0,14.4,4.8,27.5,13.6,36.9c8.7,9.4,20.6,14.5,33.7,14.5 c11.6,0,20.9-4.1,27.3-11.8v9.5h18.1V94.3H356.5z"/><path style="fill:#FFFFFF;" class="st0" d="M468,65.9c20.1,0,29.1,18,29.1,35.8c0,9.4-2.5,18.1-7,24.3c-5.1,7.1-12.8,10.9-22.1,10.9 c-9.5,0-17.3-3.8-22.5-10.9c-4.6-6.2-7.1-14.9-7.1-24.3C438.3,83.8,447.5,65.9,468,65.9 M504.9,66.3c-8.7-10.7-21.5-16.4-36.9-16.4 c-33.9,0-49.1,26-49.1,51.7c0,13.6,4.2,26.1,11.7,35.2c8.7,10.5,21.7,16,37.4,16c15.5,0,28.3-5.5,36.9-16 c7.5-9.1,11.6-21.6,11.6-35.2C516.5,88.1,512.4,75.5,504.9,66.3"/><polygon style="fill:#FFFFFF;" class="st0" points="599.4,52.2 599.4,128.7 553.8,52.2 529.1,52.2 529.1,150.5 546.7,150.5 546.7,74.2 591.6,150 591.9,150.5 617,150.5 617,52.2 "/></svg>'}}></div>
			</div>
		</div>
	)
	
}
export default WithConsumer(Cover);